import React, { useState } from "react";
import Input from "components/Inputs/Input";
import Button from "components/Button";
import getEnvironment from "environments";
import { consultarUrlPorPin } from "network/Api/DocumentoPos";
import Modal from "components/modal/ModalConfirmacion";

const urlS3 = `https://s3.us-east-2.amazonaws.com/${
  getEnvironment().bucketS3
}/`;

function Tirilla() {
  const [state, setState] = useState({});

  const consultarDocumento = () => {
    consultarUrlPorPin({ pin: state.pin }).then((res) => {
      const urlBucket = res.data;
      if (urlBucket) {
        const isOpen = window.open(urlS3 + res.data);
        if (!isOpen)
          openModal({
            mensaje: "Las ventanas emergentes estan deshabilitadas",
          });
      } else
        openModal({
          mensaje: "El pin ingresado es incorrecto",
        });
    });
  };

  const openModal = ({ mensaje }) =>
    setState((s) => ({ ...s, open: true, mensaje }));

  const handleChange = (event) => {
    const label = event.target.name;
    const value = event.target.value;
    setState((s) => ({ ...s, [label]: value }));
  };

  return (
    <>
      <div
        style={{
          margin: "40px auto",
          display: "flex",
          alignItems: "flex-end",
          width: "500px",
        }}
      >
        <Input
          label="Codigo del documento"
          name="pin"
          onChange={handleChange}
          value={state.pin || ""}
          margin="0px 5px"
        />
        <Button style={{ margin: "0px 5px" }} onClick={consultarDocumento}>
          Consultar
        </Button>
      </div>
      <Modal
        open={state.open || false}
        content={state.mensaje}
        onAccept={() => setState((s) => ({ ...s, open: false }))}
      />
    </>
  );
}

export default Tirilla;
